import { jsx as t } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import { SvgIconRoot as n } from "./svg-icon.styles.js";
const p = f(
  function(o, r) {
    return /* @__PURE__ */ t(n, { ref: r, ...o });
  }
);
export {
  p as default
};
//# sourceMappingURL=svg-icon.component.js.map
